module.exports = __webpack_public_path__ + "static/media/success.aef79701.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/success.jpg
 ** module id = 16
 ** module chunks = 0
 **/